// extracted by mini-css-extract-plugin
export var card = "_m1-1";
export var summary = "_m1-0";